import { APP_SIZES, WITH_APP_PAGE_BODY_SIZES_CLASS_NAME } from "Common/componentUtils/constants";
import includes from "lodash/includes";
import styled from "styled-components";
export default {
    PageContainer: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["sidebarWidth"], prop)
    }) `
    .dx-drawer-wrapper {
      height: 100vh;
      width: 100vw;
      .dx-drawer-panel-content {
        position: fixed;
        top: 0;
        bottom: 0;
        height: 100vh;
        z-index: ${({ theme }) => parseInt(theme["zindex-navbar-fixed"]) + 2};
      }
      .dx-drawer-content {
        margin-left: ${({ sidebarWidth }) => sidebarWidth}px;
        transition: all 0.15s;
      }
    }
  `,
    PageHeader: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["sidebarWidth"], prop)
    }) `
    padding: 16px 16px 16px 4px;
    display: grid;
    grid-template-columns: auto 1fr auto auto;
    height: 56px;
    align-items: center;
    overflow: hidden;
    margin-bottom: 16px;
  `,
    PageHeaderUser: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["sidebarWidth"], prop)
    }) `
    display: grid;
    grid-template-columns: auto auto 1fr;
    gap: 16px;
    overflow: hidden;
    align-items: center;
  `,
    PageHeaderUserName: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["sidebarWidth"], prop)
    }) `
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
    align-items: center;
    color: #112232;
  `,
    PageContentInner: styled.div `
    min-height: calc(100vh - ${APP_SIZES.HEADER_HEIGHT}px);
    max-height: calc(100vh - ${APP_SIZES.HEADER_HEIGHT}px);
    margin-top: ${APP_SIZES.HEADER_HEIGHT}px;
    overflow-y: hidden;

    > *:only-child,
    .${WITH_APP_PAGE_BODY_SIZES_CLASS_NAME} {
      min-height: calc(100vh - ${APP_SIZES.HEADER_HEIGHT}px);
      max-height: calc(100vh - ${APP_SIZES.HEADER_HEIGHT}px);
      overflow-y: hidden;
    }
  `
};
